
// @ts-nocheck


export const localeCodes =  [
  "zh-CN",
  "en-US"
]

export const localeMessages = {
  "zh-CN": [{ key: "../../locales/zh-CN.json", load: () => import("../../locales/zh-CN.json" /* webpackChunkName: "locale__var_jenkins_home_workspace_qboson_web_locales_zh_CN_json" */), cache: true }],
  "en-US": [{ key: "../../locales/en-US.json", load: () => import("../../locales/en-US.json" /* webpackChunkName: "locale__var_jenkins_home_workspace_qboson_web_locales_en_US_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../../i18n.config.ts?hash=6f1bd256&config=1" /* webpackChunkName: "__i18n_config_ts_6f1bd256" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "zh-CN",
      "iso": "zh-CN",
      "name": "中文",
      "files": [
        "../locales/zh-CN.json"
      ]
    },
    {
      "code": "en-US",
      "iso": "en-US",
      "name": "English",
      "files": [
        "../locales/en-US.json"
      ]
    }
  ],
  "defaultLocale": "zh-CN",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "locales",
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const nuxtI18nOptionsDefault = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false
}

export const nuxtI18nInternalOptions = {
  "__normalizedLocales": [
    {
      "code": "zh-CN",
      "iso": "zh-CN",
      "name": "中文",
      "files": [
        {
          "path": "../locales/zh-CN.json"
        }
      ]
    },
    {
      "code": "en-US",
      "iso": "en-US",
      "name": "English",
      "files": [
        {
          "path": "../locales/en-US.json"
        }
      ]
    }
  ]
}

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

